import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { setMessage } from '../../../../app/reducers/message-slice';
import { useDispatch, useSelector } from 'react-redux';
import { createUserRequest } from '../../infrastructure/api/wallet.api';

export const Withdraw = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user, accessToken } = useSelector((state: any) => state.authorization);

  const handleSubmit = async (data) => {
    const response = await createUserRequest(
      {
        kind: 'withdraw',
        amount: Number(data.amount),
        note: data.note,
      },
      accessToken,
    );

    if (response.status === 400)
      return dispatch(
        setMessage({
          value: 'Something went wrong',
          type: 'error',
          timeout: 3000,
        }),
      );

    dispatch(
      setMessage({
        value: 'Request is create successfully',
        timeout: 3000,
      }),
    );
  };

  return (
    <div className="wallet-fund border-1 br-8">
      <h1 className="title fs-5">{t('wallet-page.withdraw.title')}</h1>
      <p className="mt-1 mb-1 fs-6">{t('wallet-page.withdraw.description')}</p>
      {user && (
        <Formik<any>
          initialValues={{ amount: '', note: '' }}
          validate={(values) => {
            const errors = {};
            if (!values.amount) errors.amount = t('form.required');
            return errors;
          }}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="row mb-4">
                <div className="col-2">
                  <div className="form-group">
                    <Form.Label htmlFor="amount">{t('wallet-page.amount')}</Form.Label>
                    <Form.Control
                      id="amount"
                      name="amount"
                      className={`${errors.amount && touched.amount ? 'is-invalid' : ''}`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.amount}
                    ></Form.Control>
                  </div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-2">
                  <div className="form-group">
                    <Form.Label htmlFor="note">{t('wallet-page.withdraw.form.note')}</Form.Label>
                    <Form.Control
                      multiple
                      id="note"
                      name="note"
                      className={`${errors.note && touched.note ? 'is-invalid' : ''}`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.note}
                    ></Form.Control>
                  </div>
                </div>
              </div>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {t('wallet-page.withdraw.action')}
              </button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Withdraw;
